<template>
	<div class="blockItem">
		<div class="blockBody">
			<div class="blockTitle">
				<div class="blockTitleL">德育评价趋势图</div>
				<!-- <div class="blockTitleR">66666</div> -->
			</div>
			<dv-charts class="echarts" :option="option" />
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				option: {},
				option1: {
					title: {
						text: this.$utils.outputdollars(141551511),
						offset: [0, 20],
						style: {
							fill: '#0971fc',
							fontSize: 30,
							textAlign: 'right',
						}
					},
					legend: {
						top: 15,
						right: 10,
						textStyle: {
							fontFamily: 'Arial',
							// fontSize: 16,
							fill: '#FFFFFF'
						},
						// data: ['系列A', '系列B', '系列C']
						data: [
							{
								name: '累计评价数',
								color: 'rgba(55, 162, 218, 1)'
							}
						]
					},
					xAxis: {
						data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
						axisLine: {
							style: {
								stroke: '#FFFFFF',
							}
						},
						axisTick: {
							style: {
								stroke: '#FFFFFF',
							}
						},
						axisLabel: {
							style: {
								stroke: '#FFFFFF',
							}
						},
					},
					yAxis: {
						data: 'value',
						max: 5000,
						axisLine: {
							style: {
								stroke: '#FFFFFF',
							}
						},
						axisTick: {
							style: {
								stroke: '#FFFFFF',
							}
						},
						axisLabel: {
							style: {
								stroke: '#FFFFFF',
							}
						},
						splitLine: {
							show: false
						}
					},
					series: [{
							name: '累计评价数',
							data: [1200, 2230, 1900, 2000, 3500, 4200, 4800],
							type: 'line',
							// stack: 'a',
							fill: {
								show: true
							},
							lineStyle: {
								stroke: 'rgba(55, 162, 218, 1)'
							},
							lineArea: {
								show: true,
								gradient: ['rgba(55, 162, 218, 0.8)', 'rgba(55, 162, 218, 0)']
							}
						}
					]
				},
				option2: {
					title: {
						text: this.$utils.outputdollars(1002),
						offset: [0, 20],
						style: {
							fill: '#0971fc',
							fontSize: 34,
							textAlign: 'right',
						}
					},
					legend: {
						top: 15,
						right: 10,
						textStyle: {
							fontFamily: 'Arial',
							fontSize: 16,
							fill: '#FFFFFF'
						},
						// data: ['系列A', '系列B', '系列C']
						data: [
							{
								name: '每日评价数',
								color: 'rgba(251, 114, 147, 1)'
							}
						]
					},
					xAxis: {
						data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
						axisLine: {
							style: {
								stroke: '#FFFFFF',
							}
						},
						axisTick: {
							style: {
								stroke: '#FFFFFF',
							}
						},
						axisLabel: {
							style: {
								stroke: '#FFFFFF',
							}
						},
					},
					yAxis: {
						data: 'value',
						max: 2000,
						axisLine: {
							style: {
								stroke: '#FFFFFF',
							}
						},
						axisTick: {
							style: {
								stroke: '#FFFFFF',
							}
						},
						axisLabel: {
							style: {
								stroke: '#FFFFFF',
							}
						},
						splitLine: {
							show: false
						}
					},
					series: [
						{
							name: '每日评价数',
							data: [1000, 1300, 1000, 500, 2000, 1900, 300],
							type: 'line',
							// stack: 'a',
							// smooth: true,
							lineStyle: {
								stroke: 'rgba(251, 114, 147, 1)'
							},
							lineArea: {
								show: true,
								gradient: ['rgba(251, 114, 147, 0.8)', 'rgba(251, 114, 147, 0)']
							}
						}
					]
				}
			}
		},
		mounted() {
			this.option = this.option1
			let num = 0;
			setInterval(()=>{
				num++;
				let time = num%2;
				if(time===1) {
					this.option = this.option2
				} else {
					this.option = this.option1
				}
			},7000)
		}
	}
</script>

<style lang="less" scoped>
	.echarts {
		margin-top: -30px;
		height: 92%;
		width: 100%;
	}
</style>
